import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';

export const inOutList = trigger('inOutList', [
  state('ready', style({opacity: 1})),
  transition('void => ready', animate('400ms 0s ease-in', keyframes([
    style({opacity: 0, transform: 'translateX(-30px)', offset: 0}),
    style({opacity: 0.8, transform: 'translateX(10px)', offset: 0.8}),
    style({opacity: 1, transform: 'translateX(0px)', offset: 1})
  ]))),
  transition('ready => void', animate('300ms 0s ease-out', keyframes([
    style({opacity: 1, transform: 'translateX(0px)', offset: 0}),
    style({opacity: 0.8, transform: 'translateX(-10px)', offset: 0.2}),
    style({opacity: 0, transform: 'translateX(30px)', offset: 1})
  ])))
]);

export const detailExpand = trigger('detailExpand', [
  state('expanded', style({overflow: 'hidden', height: '*'})),
  state('collapsed', style({opacity: '0', overflow: 'hidden', height: '0px', 'padding-bottom': '0', 'padding-top': '0'})),
  transition('expanded <=> collapsed', animate('500ms ease-in-out'))
]);

export const rotatedState = trigger('rotatedState', [
  state('default', style({ transform: 'rotate(0)' })),
  state('rotated', style({ transform: 'rotate(90deg)' })),
  transition('rotated <=> default', animate('500ms ease-out')),
]);

export const easeInOut = trigger('easeInOut', [
  state('in', style({opacity: '1', display: 'block'})),
  state('out', style({opacity: '0', display: 'none'})),
  transition('in <=> out', animate('500ms ease-in-out'))
]);

export const slide = trigger('slide', [
  state('ready', style({opacity: 1})),
  transition('void => ready', animate('400ms 0s ease-in', keyframes([
    style({ transform: 'translateY(-30px)'}),
    style({ transform: 'translateY(10px)'}),
    style({ transform: 'translateY(0px)'})
  ]))),
  transition('ready => void', animate('300ms 0s ease-out', keyframes([
    style({ transform: 'translateY(0px)'}),
    style({ transform: 'translateY(-10px)'}),
    style({ transform: 'translateY(30px)'})
  ])))
]);
